<template>
    <div class="content">

        <settings-header />
        <settings-main v-if="checkSubmenu('main')"/>
        <settings-api v-if="checkSubmenu('api')"/>
        <settings-auth v-if="checkSubmenu('auth')"/>
        <settings-email v-if="checkSubmenu('email')"/>
    </div>
</template>

<script>
    import SettingsHeader from './SettingsHeader';
    import SettingsMain from './SettingsMain';
    import SettingsApi from './SettingsApi';
    import SettingsAuth from './SettingsAuth';
    import SettingsEmail from './SettingsEmail';

    export default {
        name: "Settings",
        components: { SettingsHeader, SettingsMain, SettingsApi, SettingsAuth, SettingsEmail },

        methods: {
            checkSubmenu (type) {
                return this.getSubmenu === type;
            }
        },

        computed: {
            getSubmenu () {
                return this.$store.state.submenu;
            }
        }
    }
</script>
